<jd-button>
  
  <button if={ props.href === undefined }
          type="button"
          disabled="{ props.disabled }"
          onclick="{ onButtonClick }"
          data-linkid={ props.datalinkid }
          data-linktype={ props.datalinktype }>
    <slot/>
  </button>

  <a if={ props.href !== undefined && !props.sameWindow}
          type="button"
          disabled="{ props.disabled }"
          href="{ props.href }"
          target="_blank"
          data-linkid={ props.datalinkid }
          data-linktype={ props.datalinktype }>
    <slot/>
  </a>

  <a if={ props.href !== undefined && props.sameWindow}
          type="button"
          disabled="{ props.disabled }"
          href="{ props.href }"
          data-linkid={ props.datalinkid }
          data-linktype={ props.datalinktype }>
    <slot/>
  </a>
  
  
  <script type="ts">
    import {RiotComponentExport} from 'riot';
    interface Props {
      variant?: 'primary' | 'secondary' | 'transparent' |'transparenty' | 'text' | 'icon' | 'circle';
      size?: 'small' | 'large';
      padding?: 'small' | 'large';
      selected?: false;
      disabled?: false;
      onClick?: (event: Event, target: HTMLElement) => void;
      sameWindow?: false;
    }
    
    function build(): RiotComponentExport<Props, never> {
      return {
        onButtonClick(event: Event): void {
          if (this.props.onClick) {
            this.props.onClick(event, this.root);
          }
        }
      };
    }
    
    export default build;
  </script>
  
  
  <style type="scss">
    @use './src/client/sass/abstracts/colors';
    @use './src/client/sass/abstracts/fonts';
    @use './src/client/sass/abstracts/respond';
    
    :host {
      display: inline-block;
    }
    
    button, a {
      position: relative;
      padding: 0 40px;
      margin-bottom: 10px;
      background-clip: border-box;
      background-color: colors.$primary-yellow;
      border: none;
      display: block;
      color: colors.$primary-dark;
      font-family: 'jd_sans_probold', 'Helvetica Neue', Helvetica, Arial, sans-serif;
      font-size: 16px;
      line-height: 42px;
      font-weight: 700;
      text-align: center;
      cursor: pointer;
      outline: none;
      text-decoration: none;
      
      &:focus,
      &:hover {
        color: #333333;
        text-decoration: none;
        outline: none;
        cursor: pointer;
        background-color: #FDDA01;
      }
      
      &:hover {
        cursor: pointer;
      }

      @include respond.smallscreen-down {
        width: 267px;
      }

    }
    
    /* Variants */
    /* default */
    :host[variant=primary] button,
    :host[variant=primary] a {
      @extend button;
    }
    
    :host[variant=secondary] button,
    :host[variant=secondary] a {
      padding: 0.6425em 3.2855em; /* account for the 1px border */
      background-color: colors.$primary-green;
      color: inherit;
    }
    
    :host[variant=transparent] button,
    :host[variant=transparent] a {
      background: transparent;
      border: 2px solid colors.$primary-green;
      color: colors.$primary-green;
    }
    
    :host[variant=text] button,
    :host[variant=text] a {
      padding: 0;
      background: none;
      border: none;
      color: inherit;
      text-decoration: underline;
      font-family: fonts.$font-base;
    }

    :host[variant=circle] button,
    :host[variant=circle] a {
      z-index: 3;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: 2px solid colors.$primary-light;
      background-color: rgba(colors.$monochrome-dark, 0.5);
    }
    
    :host[disabled] button,
    :host[disabled] button[disabled],
    :host[disabled] a,
    :host[disabled] a[disabled] {
      color: colors.$monochrome-light;
      background-color: colors.$monochrome-light;
      border: 1px solid colors.$monochrome-light;
      cursor: default;
    }

    :host[variant=transparenty] button,
    :host[variant=transparenty] a {
      transition: all 0.5s ease-out;
      background: transparent;
      border: 2px solid colors.$primary-yellow;
      color: colors.$primary-yellow;
      text-decoration: none;
      &:hover,
      &:focus {
        color: #333333;
        text-decoration: none;
        outline: none;
        cursor: pointer;
        background-color: #FDDA01;
      }
    }
    
    /* stylelint-disable no-descending-specificity */
    /* Sizes + Padding */
    :host[padding=small] button,
    :host[padding=small] a {
      padding: 0.714em 1.571em;
    }
    :host[padding=large] button,
    :host[padding=large] a {
      padding: 0.714em 7.143em;
    }
    
    /* large = default */
    /* small */
    :host[size=small] button,
    :host[size=small] a {
      padding: 0.429em 1.143em;
    }
    
    :host[size=large] button,
    :host[size=large] a {
      padding: 0.929em 3.2855em;
    }
    
    /* Inverse Button Style */
    :host[inverse] button,
    :host[inverse] a {
      &,
      &:focus,
      &:hover {
        background-color: colors.$primary-light;
        color: colors.$primary-dark;
      }
    }
    
    :host[inverse][variant=secondary] button,
    :host[inverse][variant=secondary] a {
      &,
      &:focus,
      &:hover {
        background-color: colors.$primary-dark;
        border: 1px solid colors.$primary-light;
        color: inherit;
      }
    }
    
    :host[inverse][variant=text] button,
    :host[inverse][variant=text] a {
      &,
      &:focus,
      &:hover {
        background: none;
        border: none;
        color: inherit;
      }
    }
    
    :host[inverse][variant=icon] button,
    :host[inverse][variant=icon] a {
      &,
      & i,
      & path,
      &:focus,
      &:hover {
        background: none;
        border: none;
        color: inherit;
        fill: colors.$primary-light;
      }
    }

    /* stylelint-enable no-descending-specificity */
  </style>

</jd-button>
